import React, { useCallback, useEffect, useState } from "react";
import { getMatchScoreAPI } from "../service/AuthService";
import axios from "axios";

export default function CustomScoreCard({ eventId }) {
  const [scoreData, setScoreData] = useState(null);

  console.log("test")

  const fetchScore = useCallback(async () => {
    if (!eventId) {
      setScoreData(null);
      return;
    }
    try {
      const response = await getMatchScoreAPI(eventId);
      console.log("response", response?.response?.Data?.Score?.[0]);
      setScoreData(response?.response?.Data?.Score?.[0] || null);
    } catch (error) {
      console.error("Unable to load cricket score", error);
    }
  }, [eventId]);

  useEffect(() => {
    fetchScore();

    const interval = setInterval(fetchScore, 2000);
    return () => clearInterval(interval);
  }, [fetchScore]);

  const balls = scoreData
    ? [
        scoreData.CurrentOverBalls1,
        scoreData.CurrentOverBalls2,
        scoreData.CurrentOverBalls3,
        scoreData.CurrentOverBalls4,
        scoreData.CurrentOverBalls5,
        scoreData.CurrentOverBalls6,
      ].filter((ball) => ball !== undefined && ball !== null && ball !== "")
    : [];

  const ballClass = (ball) => {
    const value = String(ball).toLowerCase();
    if (value.includes("w")) return "custom-scorecard__ball--wicket";
    if (value === "4" || value === "6") return "custom-scorecard__ball--boundary";
    return "custom-scorecard__ball--run";
  };

  return (
    <section className="custom-scorecard" aria-label="Live cricket score">
      <div className="custom-scorecard__teams">
        <div className="custom-scorecard__line">
          <span>{scoreData?.Team1Name_Short || ""}</span>
          <strong>{scoreData?.Team1Score || ""}</strong>
        </div>
        <div className="custom-scorecard__line custom-scorecard__line--chasing">
          <span>{scoreData?.Team2Name_Short || ""}</span>
          <strong>{scoreData?.Team2Score || ""}</strong>
          {scoreData?.CRR && <em>CRR {scoreData.CRR}</em>}
        </div>
      </div>

      <div className="custom-scorecard__status">
        <div className="custom-scorecard__commentary">{scoreData?.LiveCommentary || ""}</div>
        <div className="custom-scorecard__balls">
          {balls.map((ball, index) => (
            <span className={`custom-scorecard__ball ${ballClass(ball)}`} key={`${ball}-${index}`}>
              {ball}
            </span>
          ))}
        </div>
      </div>

      <style>{`
        .custom-scorecard { min-height: 80px; display: flex; overflow: hidden; color: #fff; font-size: 18px; line-height: 1.2; background: linear-gradient(90deg, rgb(33 33 33 / 39%) 0 50%, rgb(33 33 33 / 39%) 50% 100%), url('/ground_img.jpg') center/cover; border: 1px solid rgba(255,255,255,.35); }
        .custom-scorecard__teams { width: 52%; padding: 7px 8px; }
        .custom-scorecard__line { min-height: 32px; display: grid; grid-template-columns: minmax(55px,1fr) auto; align-items: center; gap: 12px; text-shadow: 0 1px 1px #000; }
        .custom-scorecard__line--chasing { grid-template-columns: minmax(55px,1fr) auto minmax(88px,1fr); }
        .custom-scorecard__line strong { font-weight: 600; white-space: nowrap; }
        .custom-scorecard__line em { font-style: normal; font-size: 16px; white-space: nowrap; }
        .custom-scorecard__status { flex: 1; min-width: 0; padding: 7px 9px; display: flex; flex-direction: column; justify-content: space-between; text-shadow: 0 1px 1px #000; }
        .custom-scorecard__commentary { min-height: 25px; overflow: hidden; text-align: right; white-space: nowrap; text-overflow: ellipsis; }
        .custom-scorecard__balls { display: flex; justify-content: flex-end; gap: 7px; min-height: 31px; }
        .custom-scorecard__ball { width: 31px; height: 31px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; color: #fff; font-size: 16px; font-weight: 600; text-shadow: none; }
        .custom-scorecard__ball--run { background: #078bcf; }
        .custom-scorecard__ball--boundary { background: #078bcf; }
        .custom-scorecard__ball--wicket { background: #f00; }
        @media (max-width: 575px) { .custom-scorecard { font-size: 15px; } .custom-scorecard__teams { width: 56%; } .custom-scorecard__line { gap: 5px; } .custom-scorecard__line--chasing { grid-template-columns: minmax(30px,1fr) auto minmax(52px,1fr); } .custom-scorecard__line em { font-size: 13px; } .custom-scorecard__status { padding-left: 3px; } .custom-scorecard__commentary { font-size: 13px; } .custom-scorecard__balls { gap: 3px; } .custom-scorecard__ball { width: 25px; height: 25px; font-size: 13px; } }
      `}</style>
    </section>
  );
}
